export default __webpack_public_path__ + "static/media/marrigeSelected.7e5a9213.svg";